export default DOMParser;
